import {PagedDataItem} from '@app/views/databrowsing/model/paged-data';
import {DistrictEntity, Guid, IEntity, ILightEntity} from '@app/views/databrowsing/model/common.data.models';

export class ResourceModel extends DistrictEntity implements IEntity {
    schoolId: Guid;
    title: string;
    roles: RoleEnum[];
    importance: Importance;
    vendorResourceId: string;
    vendorId: string;
    applicationId: string;
    /*
    * links (linkedEntities?):
    * - School
    * */
}

export class ResourceLightModel implements ILightEntity {
    guid = '';
    idValue = '';
    localId = '';
    schoolId = '';
    schoolName = '';
    districtName = '';

    title = '';

    createdAt = '';
    lastUpdated = '';

    constructor(data?: PagedDataItem<ResourceModel>) {
        if (!data) {
            return;
        }
        const resource = data.data;
        this.guid = resource.guid ? resource.guid.guidValue : '';
        this.localId = resource.localId;
        this.schoolId = resource.schoolId ? resource.schoolId.guidValue : '';
        this.schoolName = data.linkedEntities &&
        data.linkedEntities['school'] && (data.linkedEntities['school'].length > 0) && data.linkedEntities['school'][0].name
            ? data.linkedEntities['school'][0].name
            : this.schoolId;

        this.title = resource.title;

        this.createdAt = resource.createdAt;
        this.lastUpdated = resource.lastUpdatedAt;

        if (resource.districtId && (this.schoolId === resource.districtId.guidValue)) {
            this.districtName = this.schoolName;
            this.schoolName = this.schoolId;

            if (!this.districtName || this.districtName === this.schoolName) {
                this.districtName = data.linkedEntities &&
                data.linkedEntities['district'] && (data.linkedEntities['district'].length > 0) && data.linkedEntities['district'][0].name
                    ? data.linkedEntities['district'][0].name
                    : this.schoolName;
            }
        }
    }
}

export enum RoleEnum {
    TEACHER = 'TEACHER', // teacher
    STUDENT = 'STUDENT', // student
    PARENT = 'PARENT', // parent
    GUARDIAN = 'GUARDIAN', // guardian
    RELATIVE = 'RELATIVE', // relative
    AIDE = 'AIDE', // aide
    ADMINISTRATOR = 'ADMINISTRATOR', // administrator
    PROCTOR = 'PROCTOR' // proctor
}

export enum Importance {
    PRIMARY = 'PRIMARY', // primary
    SECONDARY = 'SECONDARY' // secondary
}
